import React from 'react';
import ConnectionPopup from '../connectionPopup';
import { isMobile } from '../../../core/helpers/isMobile';

function ConnectionPopupWrapper() {
  return <ConnectionPopup x={!isMobile() && 534} y={!isMobile() && 308} />;
}
export default ConnectionPopupWrapper;
